<div class="wrapper mb-2">
    <div class="row">
        <div class="col-md-5 col-sm-12 text-left">
            <img src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Nova Recarga</span>
        </div>
        <div class="col-md-7 col-sm-12 p-0">
            <div class="row container-fluid menu-navegacao-borda m-0 bg-white">
                <div class="menu-navegacao-espacamento col d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">PRODUTOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">FAVORECIDOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">CRÉDITO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">CONFIRMAÇÃO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">PAGAMENTO</span>
                </div>
            </div>
        </div>
        <div class="component-box container-fluid bg-white">
            <div class="container-fluid">
                <div class="col-lg-12 col-md-12 col-sm-12 text-left mt-5 mb-1">
                    <div class="row button-container mb-3">
                        <div class="col-12 component-title">Pagamento</div>
                    </div>

                    <!--Info pagamento-->
                    <!--Transferencia-->
                    <!--<div *ngIf="(tipoPagamento === tipoMeioPagamentoPedidoTela.Transferencia && currentPedidoInfoValue.pedidoTransferenciaInfo) && currentPedidoInfoValue.pedido.meioPagamentoPedidoId !== 4" class="row">
                        <div class="col-6 vl-right p-5">
                            <div class="title">Conta de origem</div>
                            <div>Banco: {{currentPedidoInfoValue.pedidoTransferenciaInfo.origem.bancoNome}}</div>
                            <div>Número do banco: {{currentPedidoInfoValue.pedidoTransferenciaInfo.origem.banco}}
                            </div>
                            <div>Agência: {{currentPedidoInfoValue.pedidoTransferenciaInfo.origem.agencia}}<span *ngIf="currentPedidoInfoValue.pedidoTransferenciaInfo.origem.digitoAgencia">-{{currentPedidoInfoValue.pedidoTransferenciaInfo.origem.digitoAgencia}}</span>
                            </div>
                            <div>Conta: {{currentPedidoInfoValue.pedidoTransferenciaInfo.origem.conta}} -{{currentPedidoInfoValue.pedidoTransferenciaInfo.origem.digitoConta}}
                            </div>
                            <br>
                            <div *ngIf="tipoPagamento === tipoMeioPagamentoPedidoTela.Transferencia && currentPedidoInfoValue.pedidoTransferenciaInfo">
                                <div class="title">Transfira para</div>
                                <div>Banco: {{currentPedidoInfoValue.pedidoTransferenciaInfo.destino.instituicao}}
                                </div>
                                <div>Número do banco: {{currentPedidoInfoValue.pedidoTransferenciaInfo.destino.banco}}
                                </div>
                                <div>Agência: {{currentPedidoInfoValue.pedidoTransferenciaInfo.destino.agencia}}
                                </div>
                                <div>Conta: {{currentPedidoInfoValue.pedidoTransferenciaInfo.destino.contaBancaria}}
                                </div>
                                <div>Código de identificação: {{currentPedidoInfoValue.pedidoTransferenciaInfo.destino.identificador}}
                                </div>
                                <div>Favorecido: {{currentPedidoInfoValue.pedidoTransferenciaInfo.destino.razaoSocial}}
                                </div>
                                <div *ngIf="currentPedidoInfoValue.pedidoTransferenciaInfo.origem.banco !== currentPedidoInfoValue.pedidoTransferenciaInfo.destino.banco">
                                    CNPJ: {{currentPedidoInfoValue.pedidoTransferenciaInfo.destino.cnpj.toString() | cnpj}}
                                </div>
                            </div>
                        </div>
                        <div class="col-6 p-5">
                            <div class="text-center title">Resumo do pedido</div>
                            <div class="form-box p-2">
                                <div *ngIf="currentPurchaseInfoValue.identifier" class="clean-title">
                                    <span class="clean-title-span">Identificação do Pedido: </span>
                                    {{currentPurchaseInfoValue.identifier }}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Data e hora da criação do pedido: </span>
                                    {{currentPurchaseInfoValue.purchaseDate  | date: 'dd/MM/yyyy HH:mm'}}</div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Produto(s): </span>
                                    <span *ngFor="let item of currentPurchaseValue.prod let i = index; ">
                                        <span *ngIf="i < (currentPurchaseValue.purchaseItens.length - 1)">
                                            {{item.order.productDescription}},
                                        </span>
                                        <span *ngIf="i == (currentPurchaseValue.purchaseItens.length - 1)">
                                            {{item.order.productDescription}}.
                                        </span>
                                    </span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Quantidade de favorecidos neste pedido: </span>
                                    {{currentPurchaseInfoValue.purchaseItens.length}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Data e hora de provisionamento: </span>
                                    {{currentPurchaseInfoValue.purchaseDate  | date: 'dd/MM/yyyy HH:mm'}}</div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Valor Total do Pedido: </span>
                                    <span *ngFor="let item of currentPurchaseValue.purchaseItens let i = index; ">

                                        <span *ngIf="i < (currentPurchaseValue.purchaseItens.length - 1)">
                                            {{item.order.productDescription}}: {{calcValorProduto(i) | currency:'BRL':true}},
                                        </span>
                                        <span *ngIf="i == (currentPurchaseValue.purchaseItens.length - 1)">
                                            {{item.order.productDescription}}: {{calcValorProduto(i) | currency:'BRL':true}}.
                                        </span>

                                    </span></div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Valor a ser pago: </span>
                                    {{currentPurchaseInfoValue.purchaseValuePay | currency:'BRL':true}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Meio de pagamento selecionado: </span>
                                    {{currentPurchaseInfoValue.paymentMethodId}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Uso do saldo remanescente: </span>
                                    <span *ngIf="currentPurchaseInfoValue.purchaseUseBalance">SIM</span>
                                    <span *ngIf="!currentPurchaseInfoValue.purchaseUseBalance">NÃO</span>
                                </div>
                            </div>
                            <button *ngFor="let item of currentPurchaseValue.purchaseItens let i = index; " class="custom-button-outline my-4 botao-detalhes" (click)="showDetails(details, item.order.orderId)">Ver
                                detalhes({{item.order.productDescription}})</button>
                        </div>
                    </div>-->
                    <!--Boleto-->
                    <div *ngIf="tipoPagamento === tipoMeioPagamentoPedidoTela.Boleto && currentPurchaseInfoValue.paymentMethodId === 1" class="row">
                        <div class="col-6 vl-right p-5">
                            <div class="title">Boleto</div>
                            <div *ngIf="currentPurchasePaymentValue.codigoBarras != null">Codigo:
                                {{currentPurchasePaymentValue.codigoBarras}}</div>
                            <div><img src="/assets/icons/boleto-icon.png" (click)="abrirBoleto()"
                                    style="cursor: pointer" /> </div>
                        </div>
                        <div class=" col-6 p-5">
                            <div class="text-center title">Resumo da recarga</div>
                            <div class="component-box p-2" style="border: 1px solid #DEDEDE;">
                                <div *ngIf="currentPurchaseInfoValue.purchaseDescription " class="clean-title">
                                    <span class="clean-title-span">Identificação da Recarga: </span>
                                    {{currentPurchaseInfoValue.purchaseDescription }}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Data e hora da criação da recarga: </span>
                                    {{currentPurchaseInfoValue.purchaseDate  | date: 'dd/MM/yyyy HH:mm'}}
                                </div>
                                <div class="clean-title" >
                                    <span class="clean-title-span">Produto(s): </span>
                                    <span *ngFor="let item of currentPurchaseValue.purchaseItens let i = index; ">
                                        <span *ngIf="i < (currentPurchaseValue.purchaseItens.length - 1)">
                                            {{item.order.productDescription}},
                                        </span>
                                        <span *ngIf="i == (currentPurchaseValue.purchaseItens - 1)">
                                            {{item.order.productDescription}}.
                                        </span>
                                    </span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Quantidade de favorecidos nesta recarga: </span>
                                    {{currentPurchaseInfoValue.purchaseItens[0].order.orderItens.length}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Data e hora de provisionamento: </span>
                                    {{currentPurchaseInfoValue.purchaseItens[0].order.releaseDate | date: 'dd/MM/yyyy HH:mm'}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Valor da taxa: </span>
                                    <span>{{currentPurchaseInfoValue.purchaseFee | currency:'BRL':true}}</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Valor total da Recarga: </span>
                                    <span>{{currentPurchaseInfoValue.purchaseValue | currency:'BRL':true}}</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Valor a ser pago: </span>
                                    {{currentPurchaseInfoValue.purchaseToPayValue | currency:'BRL':true}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Valor a ser disponibilizado: </span>
                                    <span>{{currentPurchaseInfoValue.purchaseValueToDeliver | currency:'BRL':true}}</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Meio de pagamento selecionado: </span>
                                    {{currentPurchaseInfoValue.paymentMethodDescription}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Uso do saldo remanescente: </span>
                                    <span *ngIf="currentPurchaseInfoValue.purchaseUseBalance">SIM</span>
                                    <span *ngIf="!currentPurchaseInfoValue.purchaseUseBalance">NÃO</span>
                                </div>
                            </div>
                            <button class="custom-button-outline my-4 botao-detalhes" (click)="showDetails(details, currentPurchaseInfoValue.purchaseId)">Ver
                                detalhes da recarga</button>
                        </div>
                    </div>
                    <!-- PIX -->
                    <div *ngIf="tipoPagamento === tipoMeioPagamentoPedidoTela.Transferencia && currentPurchaseInfoValue.paymentMethodId === 4" class="row">
                        <div class="col-6 p-5">
                            <div *ngIf="qrCodePix.imagemBRCode != undefined" class="col-12 modal-header clean-modal-header">
                                <div class="col-md-12 " style="text-align: center; margin-top: -16px;">
                                    <h5 class="modal-title clean-modal-title" style="font-size: 20px;">
                                        Para fazer pagamento utilizar o QRCode:
                                    </h5>
                                    <img  src="{{'data:image/png;base64,' + qrCodePix.imagemBRCode}}" class="qrcode-img"/>

                                </div>
                            </div>
                            <div>

                                <h6 class="clean-title-span">BRCode:</h6>
                                <span class="clean-title" style="font-size: 15px;"> {{qrCodePix.brCode}}</span>
                            </div>

                        </div>

                        <div class="col-6 p-5">
                            <div class="text-center title">Resumo da recarga</div>
                            <div class="component-box p-2" style="border: 1px solid #DEDEDE;">
                                <div *ngIf="currentPurchaseInfoValue.purchaseDescription" class="clean-title">
                                    <span class="clean-title-span">Identificação da Recarga: </span>
                                    {{currentPurchaseInfoValue.purchaseDescription }}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Data e hora da criação da recarga: </span>
                                    {{currentPurchaseInfoValue.purchaseDate  | date: 'dd/MM/yyyy HH:mm'}}</div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Produto(s): </span>
                                    <span *ngFor="let item of currentPurchaseValue.purchaseItens let i = index; ">
                                        <span *ngIf="i < (currentPurchaseValue.purchaseItens.length - 1)">
                                            {{item.order.productDescription}},
                                        </span>
                                        <span *ngIf="i == (currentPurchaseValue.purchaseItens.length - 1)">
                                            {{item.order.productDescription}}.
                                        </span>
                                    </span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Quantidade de favorecidos nesta recarga: </span>
                                    {{currentPurchaseInfoValue.purchaseItens[0].order.orderItens.length}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Data e hora de provisionamento: </span>
                                    {{currentPurchaseInfoValue.purchaseItens[0].order.releaseDate  | date: 'dd/MM/yyyy HH:mm'}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Valor da taxa: </span>
                                    <span>{{currentPurchaseInfoValue.purchaseFee | currency:'BRL':true}}</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Valor total da Recarga: </span>
                                    <span>{{currentPurchaseInfoValue.purchaseValue | currency:'BRL':true}}</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Valor a ser pago: </span>
                                    {{currentPurchaseInfoValue.purchaseToPayValue | currency:'BRL':true}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Valor a ser disponibilizado: </span>
                                    <span>{{currentPurchaseInfoValue.purchaseValueToDeliver | currency:'BRL':true}}</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Meio de pagamento selecionado: </span>
                                    {{currentPurchaseInfoValue.paymentMethodDescription}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Uso do saldo remanescente: </span>
                                    <span *ngIf="currentPurchaseInfoValue.purchaseUseBalance">SIM</span>
                                    <span *ngIf="!currentPurchaseInfoValue.purchaseUseBalance">NÃO</span>
                                </div>
                            </div>
                            <button class="custom-button-outline my-4 botao-detalhes" (click)="showDetails(details, currentPurchaseInfoValue.purchaseId)">Ver
                                detalhes da recarga</button>
                        </div>
                    </div>
                    <!--Saldo-->
                    <div *ngIf="tipoPagamento === tipoMeioPagamentoPedidoTela.Saldo" class="row">
                        <div class="col-6 vl-right p-5">
                            <div class="title">Pagamento da recarga utilizando o saldo</div>
                            <div>Você vai consumir seu saldo disponível no valor de: {{valorTotal | currency:'BRL':true}}</div>
                        </div>
                        <div class="col-6 p-5">
                            <div class="component-box p-2 mb-5" style="border: 1px solid #DEDEDE;">
                                <span class="clean-title-span">O processamento e disponibilização do crédito para o favorecido pode demorar até 40 segundos.</span>
                            </div>
                            <div class="text-center title">Resumo da recarga</div>
                            <div class="component-box p-2" style="border: 1px solid #DEDEDE;">
                                <div class="clean-title" *ngIf="currentPurchaseInfoValue.purchaseDescription">
                                    <span class="clean-title-span"> Identificação da Recarga: </span>
                                    {{currentPurchaseInfoValue.purchaseDescription}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Data e hora da criação da recarga: </span>
                                    {{currentPurchaseInfoValue.purchaseDate | date: 'dd/MM/yyyy HH:mm'}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Produto(s): </span>
                                    <span *ngFor="let item of currentPurchaseInfoValue.products let i = index; ">
                                        <span *ngIf="i < (currentPurchaseInfoValue.products.length - 1)">
                                            {{item}},
                                        </span>
                                        <span *ngIf="i == (currentPurchaseInfoValue.products.length - 1)">
                                            {{item}}.
                                        </span>
                                    </span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Quantidade de favorecidos nesta recarga:</span>
                                    {{currentPurchaseInfoValue.purchaseItens[0].order.orderItens.length}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Data e hora de provisionamento: </span>
                                    {{currentPurchaseInfoValue.purchaseItens[0].order.releaseDate | date: 'dd/MM/yyyy HH:mm'}}
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span">Valor da taxa: </span>
                                    <span>{{currentPurchaseInfoValue.purchaseFee | currency:'BRL':true}}</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Valor total da Recarga: </span>
                                    <span>{{currentPurchaseInfoValue.purchaseToPayValue | currency:'BRL':true}}</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Valor a ser pago: </span>
                                    <span *ngIf="currentPurchaseInfoValue.purchaseToPayValue > 0">
                                        {{currentPurchaseInfoValue.purchaseToPayValue | currency:'BRL':true}}</span>
                                    <span *ngIf="currentPurchaseInfoValue.purchaseToPayValue <= 0">R$ 0,00</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Valor a ser disponibilizado: </span>
                                    <span>{{currentPurchaseInfoValue.purchaseValueToDeliver | currency:'BRL':true}}</span>
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Meio de pagamento selecionado: </span>
                                    Saldo em conta
                                </div>
                                <div class="clean-title">
                                    <span class="clean-title-span"> Uso do saldo remanescente: </span>
                                    <span *ngIf="currentPurchaseInfoValue.purchaseUseBalance">SIM</span>
                                    <span *ngIf="!currentPurchaseInfoValue.purchaseUseBalance">NÃO</span>
                                </div>
                            </div>
                            <button class="custom-button-outline my-4 botao-detalhes" (click)="showDetails(details, currentPurchaseInfoValue.purchaseId)">Ver
                                detalhes da recarga</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row button-container mt-5 mb-5">
                <div class="col-6 text-left">
                </div>
                <div class="col-12 text-right">
                    <button (click)="create()" type="submit" class="custom-button-full">
                        Nova Recarga
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal do Detalhes-->
<ng-template #details let-modal>
    <div class="container custom-filter">
        <div class="row mx-5">
            <div class="col-12 custom-filter-title my-5">Detalhes da recarga</div>

            <div class="table-responsive custom-bg-white">
                <table class="list-table table table-striped">
                    <thead class="list-table-head">
                        <th>Nome</th>
                        <th>CPF</th>
                        <th>Matrícula</th>
                        <th>Valor</th>
                        <th>Comentário</th>
                    </thead>
                    <tbody class="list-table-row">
                        <tr *ngFor="let item of currentPedidoInfoValue.pedido.pedidoItens | paginate: { itemsPerPage: 8, currentPage: 1 }" class=" list-table-cell" class="clickable">
                            <td>{{item.nome}}</td>
                            <td>{{item.cpf | cpf}}</td>
                            <td>{{item.matricula}}</td>
                            <td>{{item.valor | currency:'BRL':true}}</td>
                            <td>{{item.comentario}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-12 text-center my-5">
                <button class="custom-filter-button" type="button" (click)="modal.dismiss('Close click')">
                    Fechar
                </button>
            </div>
        </div>
    </div>
</ng-template>
